import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Typography,
    Box,
    Switch,
    FormControlLabel
} from '@mui/material';
import { Close, Print } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const PrintOptionsModal = ({ open, onClose, onPrint }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;
    const [includePrices, setIncludePrices] = useState(true);
    const [showAgentLogo, setShowAgentLogo] = useState(true);

    const handlePrint = () => {
        onPrint({ includePrices, showAgentLogo });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">
                        {lang === 'ar' ? 'خيارات الطباعة' : 'Print Options'}
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Box py={1}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={includePrices}
                                onChange={(e) => setIncludePrices(e.target.checked)}
                                color="primary"
                            />
                        }
                        label={lang === 'ar' ? "تضمين السعر في الطباعة" : "Include Prices in Print"}
                    />
                </Box>
                <Box py={1}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={showAgentLogo}
                                onChange={(e) => setShowAgentLogo(e.target.checked)}
                                color="primary"
                            />
                        }
                        label={lang === 'ar' ? "إظهار لوجو الوكالة" : "Show Agent Logo"}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    {lang === 'ar' ? 'إلغاء' : 'Cancel'}
                </Button>
                <Button
                    onClick={handlePrint}
                    variant="contained"
                    color="primary"
                    startIcon={<Print />}
                >
                    {lang === 'ar' ? 'طباعة' : 'Print'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PrintOptionsModal;
